import { Grid, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import AcquirerItem from "../AcquirerItem";
import "./style.css";
import LoadingDefault from "../LoadingDefault";

const AcquirerSelection = ({ ...props}) => {
  const [acquirersActives, setAcquirersActives] = useState([]);
 
  useEffect(() => {
    setAcquirersActives(props.acquirers.acquirersActives.acquirersActives);
  }, [props]);

  return (
    <div>
      <Grid>
        <Typography
          variant="h6"
          component="h4"
          style={{
            fontSize: "2.15rem",
            display: "flex",
            justifyContent: "center",
          }}
          color="textSecondary"
        >
          <strong>PAGAMENTO COM CARTÃO</strong>
        </Typography>
        <Typography variant="h6" component="h3" color="textSecondary">
          Selecione abaixo a credenciada que deseja realizar o pagamento.
        </Typography>
      </Grid>
      <br/>
      {props.loading && <LoadingDefault typeLoading={"card"} />}
      <Grid container>
        {acquirersActives?.length > 0 ? (
          <Grid item xs={6} sm={12} md={12}>
            <AcquirerItem
              acquirersActives={acquirersActives}
            />
          </Grid>
        ) : null}
      </Grid>
    </div>
  );
};

export default AcquirerSelection;
